module.exports = __webpack_public_path__ + "static/facebook-reviews-a2599373057420743e085d3531111f8c.png";